import * as React from "react";
import dynamic from "next/dynamic";
import { useFlags } from "launchdarkly-react-client-sdk";
import { ErrorBoundary } from "@lululemon/mwa-logger";
import { useDeviceType } from "@lululemon/ecom-site/src/util/with-device-characteristics";
import DynamicLinkProvider from "@lululemon/ecom-common/src/components/dynamic-link-provider/index";
import { productEdHandleError } from "@lululemon/ecom-common/src/util/product-education-logger";
import WhyWeMadeThisAdapter from "../components/why-we-made-this/why-we-made-this.adapter";
import CTABlockAdapter from "./v2/cta-block/cta-block.adapter";
import WYLTAdapter from "./wylt/wylt.adapter";
const FranchiseComparisonAdapter = dynamic(() =>
  import("./franchise-comparison/franchise-comparison.adapter")
);
import useWyltData from "../hooks/useWyltData";
import useFranchiseComparisonData from "../hooks/useFranchiseComparisonData";

function ProductEducationFactory() {
  // WYLT
  const { pdpWylt: pdpWyltLDFlag = false } = useFlags();
  const wyltContentfulData = useWyltData();

  // FranchiseComparison
  const { pdpFranchiseComparison: pdpFranchiseComparisonLDFlag = false } =
    useFlags();
  const franchiseComparisonContentfulData = useFranchiseComparisonData();

  const hasContentfulWyltData = wyltContentfulData?.fields;
  const hasContentfulFranchiseComparisonData =
    franchiseComparisonContentfulData?.fields;
  const { deviceType } = useDeviceType();
  const showWylt = pdpWyltLDFlag && hasContentfulWyltData;
  const showFranchiseComparison =
    pdpFranchiseComparisonLDFlag && hasContentfulFranchiseComparisonData;
  const isMobileOrTablet = deviceType.isMobile || deviceType.isTablet;
  if (showWylt) {
    return (
      <>
        <WYLTAdapter />
        {isMobileOrTablet && !showFranchiseComparison && <CTABlockAdapter />}
        {showFranchiseComparison && <FranchiseComparisonAdapter />}
        {isMobileOrTablet && showFranchiseComparison && <CTABlockAdapter />}
      </>
    );
  }
  return (
    <ErrorBoundary
      onError={(error) =>
        productEdHandleError(
          error,
          "Product Education Factory",
          "Product Education Factory"
        )
      }
    >
      <DynamicLinkProvider>
        {isMobileOrTablet && <CTABlockAdapter />}
        <WhyWeMadeThisAdapter />
        {showFranchiseComparison && <FranchiseComparisonAdapter />}
      </DynamicLinkProvider>
    </ErrorBoundary>
  );
}

export default ProductEducationFactory;
